import { useState } from "react";
import Api from "../../../../Api";
import { useTranslation } from "react-i18next";
import TeambookTextForm from "../../../default_components/TeambookTextForm";
import { useAccountStore } from "../../../../stores/accountStore";
import { shallow } from "zustand/shallow";
import { useNotificationStore } from "../../../../stores/notificationStore";
import TeambookDialog from "../../../default_components/TeambookDialog";

const CouponApplicationModal = ({ closeModal }) => {
  const { t } = useTranslation();
  const [coupon, setCoupon] = useState();
  const [errorMessage, setErrorMessage] = useState(null);
  const [errorField, setErrorField] = useState(null);

  const [fetchAccount] = useAccountStore((state) => [state.account], shallow);
  const [setInAppNotification] = useNotificationStore((state) => [state.setInAppNotification], shallow);

  const applyCoupon = () => {
    Api.Coupons.submit(coupon)
      .then(() => {
        fetchAccount();
        setInAppNotification(t("notify.settings.subscription.coupon_apply"));
        closeModal();
      })
      .catch((error) => {
        setErrorMessage(error.response.data.error);
        setErrorField("coupon");
      });
  };

  const closeErrorMessage = () => {
    setErrorMessage(null);
    setErrorField(null);
  };

  return (
    <TeambookDialog
      title={t("settings.subscription.coupon_apply")}
      onClose={closeModal}
      open={true}
      withCloseButton
      content={
        <TeambookTextForm
          fieldName={"Coupon"}
          onChange={setCoupon}
          fieldValue={coupon}
          type={"text"}
          width={"400px"}
          placeholder={"PLANX-hfSnf-...."}
          errorField={errorField}
          errorMessage={errorMessage}
          closeErrorMessage={closeErrorMessage}
          field={"coupon"}
        />
      }
      actionButtons={[
        {
          text: t("submit"),
          onClick: applyCoupon,
        }
      ]}
    />
  );
};

export default CouponApplicationModal;
